import React from 'react'
import './../css/GeneralPages.css'
import PageTitle from '../includes/PageTitle'
import Footer from '../includes/Footer'
export default function PrivacyPolicy() {
  return (
    <>
    <PageTitle title="Privacy Policy - ALMOSTINVISIBLE" />
    <div className="gen-intro px-4">
      <h1 className="unbounded text-fluid">
        Privacy Policy
      </h1>
    </div>

    <div className="gen-content container">
      <p>
      <section>
        <h2 className="unbounded">1. Introduction</h2>
        <p>
          At ALMOSTINVISIBLE, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our services, or make a purchase from our online store.
        </p>
      </section>

      <section>
        <h2 className="unbounded">2. Information We Collect</h2>
        <p>
          We may collect the following types of information when you interact with our website:
        </p>
        <ul>
          <li><strong>Personal Information:</strong> This includes your name, email address, phone number, shipping address, billing address, payment information, and other details you provide during registration or purchase.</li>
          <li><strong>Usage Data:</strong> This includes information about how you interact with our website, such as pages visited, time spent on the site, and your IP address.</li>
          <li><strong>Cookies and Tracking Technologies:</strong> We may use cookies, web beacons, and similar technologies to improve your browsing experience, personalize content, and analyze website traffic.</li>
        </ul>
      </section>

      <section>
        <h2 className="unbounded">3. How We Use Your Information</h2>
        <p>
          We use the information we collect for various purposes, including:
        </p>
        <ul>
          <li><strong>To Process Transactions:</strong> To complete your purchases, process payments, and ship your orders.</li>
          <li><strong>To Improve Our Services:</strong> To enhance the performance and functionality of our website, personalize your experience, and provide tailored recommendations.</li>
          <li><strong>To Communicate with You:</strong> To send you order confirmations, shipping updates, promotional offers, and other information you may find valuable.</li>
          <li><strong>To Provide Customer Support:</strong> To address inquiries, assist with returns or exchanges, and resolve any issues you may encounter.</li>
          <li><strong>For Marketing and Promotional Purposes:</strong> To send marketing materials, including newsletters, offers, and updates, based on your preferences and past interactions with our website.</li>
        </ul>
      </section>

      <section>
        <h2 className="unbounded">4. How We Share Your Information</h2>
        <p>
          We may share your personal information with third parties in the following situations:
        </p>
        <ul>
          <li><strong>Service Providers:</strong> We may share your information with trusted third-party service providers who assist us with website hosting, payment processing, order fulfillment, customer service, and marketing.</li>
          <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of ALMOSTINVISIBLE, your information may be transferred as part of the transaction.</li>
          <li><strong>Legal Compliance:</strong> We may disclose your information if required by law or in response to a legal request, such as a subpoena or court order.</li>
        </ul>
      </section>

      <section>
        <h2 className="unbounded">5. Data Security</h2>
        <p>
          We take the security of your personal information seriously. We use a variety of security measures to protect your data, including encryption, firewalls, and secure payment gateways. However, no method of data transmission or storage is 100% secure, and we cannot guarantee the absolute security of your information.
        </p>
      </section>

      <section>
        <h2 className="unbounded">6. Your Rights and Choices</h2>
        <p>
          You have the following rights regarding your personal information:
        </p>
        <ul>
          <li><strong>Access:</strong> You can request access to the personal information we hold about you.</li>
          <li><strong>Correction:</strong> You can request corrections to any inaccurate or incomplete personal information.</li>
          <li><strong>Deletion:</strong> You can request the deletion of your personal information, subject to any legal or contractual obligations we may have to retain it.</li>
          <li><strong>Opt-out:</strong> You can opt-out of receiving marketing communications from us by following the unsubscribe instructions in our emails or contacting us directly.</li>
        </ul>
      </section>

      <section>
        <h2 className="unbounded">7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites, such as social media platforms or payment processors. These websites have their own privacy policies, and we are not responsible for the content or practices of these third parties. We encourage you to review their privacy policies before interacting with them.
        </p>
      </section>

      <section>
        <h2 className="unbounded">8. Children's Privacy</h2>
        <p>
          Our website is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal information from a child under 13, we will take steps to delete that information.
        </p>
      </section>

      <section>
        <h2 className="unbounded">9. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page, and the "Last Updated" date will be updated accordingly. We encourage you to review this policy periodically for any changes.
        </p>
      </section>

      <section>
        <h2 className="unbounded">10. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy or how we handle your personal information, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:vlmstnvsbl@vlmstnvsbl.com ">info@vlmstnvsbl.com </a>
        </p>
      </section>


        <p>Last updated: December 2024</p>
      </p>
    </div>
<Footer />
</>
  )
}
